export default __webpack_public_path__ + "locales/uk-UA/JavascriptSdk.json?hash=769da0bae946b55793f84e23a7ad2179";